import { initializeApp } from 'firebase/app';
import { getFirestore, doc, collection, setDoc, addDoc } from 'firebase/firestore';
import React, { useContext, useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast';

import { AuthContext } from '../../context/auth';
import { TaskContext } from '../../context/task';
import { TotalViewContext } from '../../context/totalview';
import { firebaseConfig } from '../../firebaseConfig';
import logo from '../../img/kOnzy.gif';
import ListTask from './ListTask';
import { getDatabase, ref, set } from "firebase/database";
import uniqid from 'uniqid';
export default function CreateTask() {
    // Initialize Firebase
    const app = initializeApp(firebaseConfig);

    // Initialize Cloud Firestore and get a reference to the service
    const db = getFirestore(app);
    const [task, setTask] = useState("");
    const [postedBy, setPostedBy] = useState("");
    const [totalView, setTotalView] = useContext(TotalViewContext);

    const [loading, setLoading] = useState();

    // const [load, setLoad] = useState();
    const [tasks, setTasks ] = useContext(TaskContext);
    const [auth, setAuth] = useContext(AuthContext);
    useEffect(() => {
        setPostedBy(auth?.email)
      return () => {
        
      }
    }, [])

    const createRealTask=async(e)=>{
        e.preventDefault();
        function writeUserData(postedBy, taskq, ) {
            const id=uniqid()
            const date=new Date().getTime()
            const db = getDatabase();
          const sets=  set(ref(db, 'tasks/' + id), {
            task:taskq,
            postedBy,
            id,
            timeCreated:String(new Date(date)),
            updatedTime:''
              
            });
            console.log(sets)
          }
          writeUserData(postedBy,task)
         
    }
    const createTask = async (e) => {
        e.preventDefault();
        try {

            setLoading(true)
            const newTaskRef = collection(db, "task");
            const date=new Date().getTime()
            const data = {
                task,
                postedBy,
                timeCreated:String(new Date(date)),
                updatedTime:''

            }
            await addDoc(newTaskRef, data).then((docRef)=> {
                data.id=docRef.id
                
            });
            
            toast.success("task created")
            setTasks([data,...tasks])
            setTask("")
            console.log(data)
            setLoading(false)
            setTotalView(pre=>({...totalView,  totalView:pre.totalView+1, total:pre.total+1}))
        } catch (error) {
            setLoading(false)
            toast.error("error"+error.message)
            console.log("error"+error)
        }
    }
    
    

    
    return (
        <>
        <Toaster />
        <div className="container">
            <div className="row">
                <div className="col-md-6 offset-md-3">
            <form className='d-flex justify-content'>
                <textarea className='form-control m-1' value={task} maxLength={160} onChange={(e) => setTask(e.target.value)} placeholder='Write' ></textarea>
                        
                <button  onClick={createRealTask} type='submit' className='btn btn-warning m-1'>{ loading ? (<img src={logo} alt="loading" style={{height:"20px"}}/>): "Submit"} </button>
            </form>
            </div>
            </div></div>
        </>
    )

}
